<div class="content-wrapper d-print-none">
    <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title">Employee Uploads</h4>
                    <div class="table-responsive pt-3">
                        <nz-table #verificationTable [nzData]="Uploads" [nzPageSize]="20">
                            <thead>
                                <tr>
                                    <th>
                                        Request Reference
                                    </th>
                                    

                                    <!-- <th>
                                        Contractor
                                    </th> -->

                                    <th>
                                        Uploaded No of Employees
                                    </th>

                                    <th>
                                        Active No of Employees
                                    </th>

                                    <th>
                                        Uploaded By
                                    </th>

                                    <th>
                                        Date Uploaded
                                    </th>

                                    <th>
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of verificationTable.data"
                                    [routerLink]="['/verifyemployees/', data.id]" class="clickable">
                                    <td>
                                        {{ data.contractReference }}
                                    </td>

                                   

                                    <!-- <td>
                                        {{data.contractorName}}
                                    </td> -->

                                    <td>
                                        {{data.numberOfEmployees}}
                                    </td>

                                    <td>
                                        {{data.numberofActiveEmployees}}
                                    </td>
                                    <td>
                                        {{data.uploadedBy}}
                                    </td>
                                    <td>
                                        {{data.createdDate | date: 'dd/MM/yyyy'}}
                                    </td>
                                    <td>
                                        <button [ngClass]="getStatusColor(data.uploadedFileStatus)">
                                            {{data.uploadedFileStatus}}</button>
                                    </td>



                                </tr>
                            </tbody>
                        </nz-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>